import {PagingModel} from '../models/paging-model';
import * as contact from '../actions/contact';
import {Contact} from '../models/contact';
import * as auth from '../actions/authentication';

export interface State {
  contactPage: Contact[];
  paging: PagingModel;
  currentContact: Contact;
  contactId: number;
  working: boolean;
}

export const initialState: State = {
  contactPage: [],
  paging: {itemsPerPage: 25, totalItems: 0, totalPages: 0, pageNumber: 1 } as PagingModel,
  currentContact: {},
  contactId: 0,
  working: false
};

export function reducer(state = initialState, action: any): State {
  let newState: State;
  switch (action.type) {
    case contact.LOAD_CONTACT_LIST:
      newState = Object.assign({}, state);
      newState.currentContact = new Contact();
      newState.contactId = 0;
      newState.paging = action.payload;
      newState.working = true;
      return newState;

    case contact.LOAD_CONTACT_LIST_COMPLETE:
      newState = Object.assign({}, state);
      newState.contactPage = action.payload.results;
      newState.paging = action.payload.paging;
      newState.working = false;
      return newState;

    case contact.SAVE_CONTACT:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case contact.SAVE_CONTACT_COMPLETE:
      newState = Object.assign({}, state);
      newState.currentContact = action.payload;
      newState.working = false;
      return newState;

    case contact.GET_CONTACT_DETAILS:
      newState = Object.assign({}, state);
      newState.working = true;
      newState.contactId = action.payload;
      return newState;

    case contact.GET_CONTACT_DETAILS_COMPLETE:
      newState = Object.assign({}, state);
      newState.currentContact = action.payload;
      newState.working = false;
      return newState;

    case contact.GET_USER_PROFILE:
      newState = Object.assign({}, state);
      newState.currentContact = new Contact();
      newState.working = true;
      return newState;

    case contact.GET_USER_PROFILE_COMPLETE:
      newState = Object.assign({}, state);
      newState.currentContact = action.payload;
      newState.working = false;
      return newState;

    case contact.SAVE_USER_PROFILE:
      newState = Object.assign({}, state);
      newState.working = true;
      return newState;

    case contact.SAVE_USER_PROFILE_COMPLETE:
      newState = Object.assign({}, state);
      newState.working = false;
      return newState;

    case 'ERROR':
      newState = Object.assign({}, state);
      newState.working = false;
      return newState;

    case auth.LOGOUT:
      return initialState;

    default:
      newState = Object.assign({}, state);
      return newState;
  }
}

export const getContactPage = (state: State) => state.contactPage;
export const getContactPaging = (state: State) => state.paging;
export const getCurrentContact = (state: State) => state.currentContact;
export const getContactWorking = (state: State) => state.working;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/reducers/contact.ts